import {createSelector} from '@reduxjs/toolkit';

import {QUOTA_TYPE_KEYS, TILE_MODE, TILE_MODE_QUOTA} from '@explorer/constants';
import {getRulesForMosaic} from './mosaics.js';

const getSubscriptionsIds = state => state.subscriptions.ids;
export const getSubscriptions = state => state.subscriptions.byId;
export const getCurrentSubIds = state => state.subscriptions.current;

const getTileMode = state => state.tiles.mode;

export const getTileQuotaSubs = createSelector(
  [getSubscriptionsIds, getSubscriptions],
  (subIds, subscriptions) => {
    const subs = [];
    subIds.forEach(id => {
      const sub = subscriptions[id];
      const quotas = [];

      if (
        !!sub[QUOTA_TYPE_KEYS.scene] &&
        sub[QUOTA_TYPE_KEYS.scene].enabled &&
        sub[QUOTA_TYPE_KEYS.scene].limit > 0
      ) {
        quotas.push(sub[QUOTA_TYPE_KEYS.scene]);
      }
      if (
        !!sub[QUOTA_TYPE_KEYS.basemap] &&
        sub[QUOTA_TYPE_KEYS.basemap].enabled &&
        sub[QUOTA_TYPE_KEYS.basemap].limit > 0
      ) {
        quotas.push(sub[QUOTA_TYPE_KEYS.basemap]);
      }

      if (quotas.length > 0) {
        subs.push(sub);
      }
    });

    return subs;
  }
);

export const getCurrentBasemapSubIds = createSelector(
  [getRulesForMosaic],
  rules => {
    return rules.map(r => r.sub);
  }
);

export const getCurrentTileQuotas = createSelector(
  [getSubscriptions, getCurrentSubIds, getTileMode, getCurrentBasemapSubIds],
  (subscriptions, currentSubIds, tileMode, basemapSubIds) => {
    if (tileMode === TILE_MODE.FOLDERS) {
      return [];
    }

    // We know basemap subscription ids based on the currently selected
    // basemap and its rules. For Scenes we depend on the x-planet-sub header
    // which sets the currentSubIds
    const subIds =
      tileMode === TILE_MODE.BASEMAPS ? basemapSubIds : currentSubIds;

    const quotaType = QUOTA_TYPE_KEYS[TILE_MODE_QUOTA[tileMode]];

    const quotas = [];

    subIds.forEach(subId => {
      const sub = subscriptions[subId];

      if (sub && sub[quotaType]?.enabled && sub[quotaType]?.limit > 0) {
        quotas.push({
          ...sub[quotaType],
          subscriptionId: subId,
          subscriptionName: sub.plan.name,
        });
      }
    });

    return quotas;
  }
);
